export default __webpack_public_path__ + "static/media/landing-page-dark.dc2b0485.png";